import AbstractLazyLoad from './AbstractLazyLoad';
import LazyLoadElementWrapper from './LazyLoadElementWrapper';

export default class PictureLazyLoad extends AbstractLazyLoad {
  constructor() {
    super('picture');
  }

  protected load(wrapper: LazyLoadElementWrapper): void {
    /* const pictureElement = wrapper.getElementAs<HTMLPictureElement>();

    pictureElement.querySelectorAll<HTMLSourceElement>('source').forEach((sourceElement: HTMLSourceElement) => {
      const { srcset } = sourceElement.dataset;
      if (srcset) {
        sourceElement.srcset = srcset;
        delete sourceElement.dataset.srcset;
      }
    });
    const imgElement = pictureElement.querySelector<HTMLImageElement>('img')!;
    const { src } = imgElement.dataset;
    if (src) {
      imgElement.src = src;
      delete imgElement.dataset.src;
    } */
  }
}